<template>
<div>
    <nav class="navbar d-flex justify-content-around align-items-center">
        <div class="container">
            <div class="logo .d-none .d-lg-block">
                <router-link to="/">
                    <img src="../assets/images/logo.png" class="animate__animated animate__rubberBand" alt="" />
                </router-link>
                <button class="lang-btn" @click="changeLang('en')" v-if="lang == 'ar'">
                    En
                </button>
                <button class="lang-btn" @click="changeLang('ar')" v-if="lang == 'en'">
                    Ar
                </button>
            </div>

            <div class="middle-navbar .d-none .d-lg-block mob-hide">
                <Menubar id="menuBar" :model="menuMobList" />
            </div>

            <Menubar class="mob-show phone-menu" :model="menuMobList" width="80dvw" />
            <div class="icons .d-none .d-lg-block mob-icon">
                {{$t('trialVersion')}}

                <a :href="'https://wa.me/' + whatsapp + '?text=from HereHome Website'"><img src="../assets/images/whatsapp.svg" style="width: 22px" /></a>

                <a @click="visibleLeft = true" class="position-relative">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.85185 3.66616H16.4074C18.5347 3.66616 20.2593 5.39069 20.2593 7.51801V12.3328C20.2593 14.4601 18.5347 16.1847 16.4074 16.1847H8.7037C6.57638 16.1847 4.85185 14.4601 4.85185 12.3328V3.66616ZM4.85185 3.66616C4.85185 2.6025 3.98959 1.74023 2.92593 1.74023H1" stroke="#313131" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.66623 19.555C9.66623 20.3528 9.01953 20.9995 8.22179 20.9995C7.42404 20.9995 6.77734 20.3528 6.77734 19.555C6.77734 18.7573 7.42404 18.1106 8.22179 18.1106C9.01953 18.1106 9.66623 18.7573 9.66623 19.555Z" stroke="#313131" stroke-width="1.5" />
                        <path d="M18.3332 19.555C18.3332 20.3528 17.6865 20.9995 16.8888 20.9995C16.091 20.9995 15.4443 20.3528 15.4443 19.555C15.4443 18.7573 16.091 18.1106 16.8888 18.1106C17.6865 18.1106 18.3332 18.7573 18.3332 19.555Z" stroke="#313131" stroke-width="1.5" />
                        <path d="M9.66699 11.3699C11.9359 12.6606 13.1795 12.647 15.4448 11.3699" stroke="#313131" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span class="position-absolute top-0 start-100 p-1 translate-middle badge rounded-pill count-bell" v-if="countCartItem > 0">
                        {{ countCartItem }}
                    </span>
                </a>
                <a @click="
              visibleLeftNtofy = true;
              showData();
            ">
                    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.31328 11.9153L1.56806 11.8307L1.56806 11.8307L2.31328 11.9153ZM2.76046 7.97519L3.50568 8.05977L2.76046 7.97519ZM1.44779 13.8721L0.876678 13.386H0.876678L1.44779 13.8721ZM16.4319 11.8307C16.3852 11.4191 16.0137 11.1233 15.6021 11.17C15.1906 11.2168 14.8948 11.5883 14.9415 11.9998L16.4319 11.8307ZM16.5522 13.8721L15.9811 14.3583L16.5522 13.8721ZM6.73005 3.37366L6.973 4.08322C7.2763 3.97938 7.48005 3.69424 7.48005 3.37366H6.73005ZM10.1539 2.28059C10.4237 2.59487 10.8973 2.6309 11.2115 2.36107C11.5258 2.09125 11.5618 1.61774 11.292 1.30347L10.1539 2.28059ZM12.7023 19.2632C12.8477 18.8753 12.6511 18.4431 12.2632 18.2977C11.8753 18.1523 11.4431 18.3489 11.2977 18.7368L12.7023 19.2632ZM6.7023 18.7368C6.55694 18.3489 6.12467 18.1523 5.7368 18.2977C5.34893 18.4431 5.15234 18.8753 5.2977 19.2632L6.7023 18.7368ZM17.25 6C17.25 7.24264 16.2426 8.25 15 8.25V9.75C17.0711 9.75 18.75 8.07107 18.75 6H17.25ZM15 8.25C13.7574 8.25 12.75 7.24264 12.75 6H11.25C11.25 8.07107 12.9289 9.75 15 9.75V8.25ZM12.75 6C12.75 4.75736 13.7574 3.75 15 3.75V2.25C12.9289 2.25 11.25 3.92893 11.25 6H12.75ZM15 3.75C16.2426 3.75 17.25 4.75736 17.25 6H18.75C18.75 3.92893 17.0711 2.25 15 2.25V3.75ZM14.7772 16.25H3.22281V17.75H14.7772V16.25ZM3.05849 11.9998L3.50568 8.05977L2.01525 7.89061L1.56806 11.8307L3.05849 11.9998ZM2.01889 14.3583C2.59621 13.6801 2.96028 12.8652 3.05849 11.9998L1.56806 11.8307C1.50519 12.3846 1.27067 12.9231 0.876678 13.386L2.01889 14.3583ZM14.9415 11.9998C15.0397 12.8652 15.4038 13.6801 15.9811 14.3583L17.1233 13.386C16.7293 12.9231 16.4948 12.3846 16.4319 11.8307L14.9415 11.9998ZM3.22281 16.25C2.56777 16.25 2.10443 15.926 1.89056 15.5492C1.68409 15.1854 1.68714 14.748 2.01889 14.3583L0.876678 13.386C0.111406 14.285 0.0877731 15.4116 0.585985 16.2895C1.07679 17.1544 2.04947 17.75 3.22281 17.75V16.25ZM14.7772 17.75C15.9505 17.75 16.9232 17.1544 17.414 16.2895C17.9122 15.4116 17.8886 14.285 17.1233 13.386L15.9811 14.3583C16.3129 14.748 16.3159 15.1854 16.1094 15.5492C15.8956 15.926 15.4322 16.25 14.7772 16.25V17.75ZM7.48005 3.37366V3.26995H5.98005V3.37366H7.48005ZM3.50568 8.05977C3.7087 6.27101 5.05587 4.73962 6.973 4.08322L6.48711 2.6641C4.11944 3.47476 2.29449 5.43026 2.01525 7.89061L3.50568 8.05977ZM9 0.25C7.33213 0.25 5.98005 1.60208 5.98005 3.26995H7.48005C7.48005 2.4305 8.16056 1.75 9 1.75V0.25ZM9 1.75C9.46131 1.75 9.87403 1.95459 10.1539 2.28059L11.292 1.30347C10.7393 0.659712 9.91709 0.25 9 0.25V1.75ZM11.2977 18.7368C10.975 19.5979 10.0846 20.25 9 20.25V21.75C10.6855 21.75 12.1516 20.7325 12.7023 19.2632L11.2977 18.7368ZM9 20.25C7.91542 20.25 7.02502 19.5979 6.7023 18.7368L5.2977 19.2632C5.84835 20.7325 7.31452 21.75 9 21.75V20.25Z" fill="#313131" />
                    </svg>
                    <span class="p-1 translate-middle badge rounded-pill count-bell count-bell2" v-if="notificationsCount > 0">
                        {{ notificationsCount }}
                    </span>
                </a>
                <a @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" v-if="user" class="person">
                    <svg width="18" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.94874 5.47436C3.94874 3.34311 5.67646 1.61538 7.80771 1.61538C9.93897 1.61538 11.6667 3.34311 11.6667 5.47436C11.6667 7.60561 9.93897 9.33333 7.80771 9.33333C5.67646 9.33333 3.94874 7.60561 3.94874 5.47436ZM7.80771 0C4.78431 0 2.33336 2.45095 2.33336 5.47436C2.33336 8.49776 4.78431 10.9487 7.80771 10.9487C10.8311 10.9487 13.2821 8.49776 13.2821 5.47436C13.2821 2.45095 10.8311 0 7.80771 0ZM2.74565 15.4584C3.46935 14.7347 4.4509 14.3281 5.47436 14.3281H10.141C11.1645 14.3281 12.146 14.7347 12.8697 15.4584C13.5934 16.1821 14 17.1636 14 18.1871V20.5204C14 20.9665 14.3616 21.3281 14.8077 21.3281C15.2538 21.3281 15.6154 20.9665 15.6154 20.5204V18.1871C15.6154 16.7352 15.0386 15.3428 14.012 14.3161C12.9853 13.2895 11.5929 12.7127 10.141 12.7127H5.47436C4.02247 12.7127 2.63004 13.2895 1.6034 14.3161C0.576761 15.3428 0 16.7352 0 18.1871V20.5204C0 20.9665 0.361616 21.3281 0.807692 21.3281C1.25377 21.3281 1.61538 20.9665 1.61538 20.5204V18.1871C1.61538 17.1636 2.02195 16.1821 2.74565 15.4584Z" fill="#313131" />
                    </svg>
                </a>

                <router-link to="/login" v-else>
                    <svg width="18" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.94874 5.47436C3.94874 3.34311 5.67646 1.61538 7.80771 1.61538C9.93897 1.61538 11.6667 3.34311 11.6667 5.47436C11.6667 7.60561 9.93897 9.33333 7.80771 9.33333C5.67646 9.33333 3.94874 7.60561 3.94874 5.47436ZM7.80771 0C4.78431 0 2.33336 2.45095 2.33336 5.47436C2.33336 8.49776 4.78431 10.9487 7.80771 10.9487C10.8311 10.9487 13.2821 8.49776 13.2821 5.47436C13.2821 2.45095 10.8311 0 7.80771 0ZM2.74565 15.4584C3.46935 14.7347 4.4509 14.3281 5.47436 14.3281H10.141C11.1645 14.3281 12.146 14.7347 12.8697 15.4584C13.5934 16.1821 14 17.1636 14 18.1871V20.5204C14 20.9665 14.3616 21.3281 14.8077 21.3281C15.2538 21.3281 15.6154 20.9665 15.6154 20.5204V18.1871C15.6154 16.7352 15.0386 15.3428 14.012 14.3161C12.9853 13.2895 11.5929 12.7127 10.141 12.7127H5.47436C4.02247 12.7127 2.63004 13.2895 1.6034 14.3161C0.576761 15.3428 0 16.7352 0 18.1871V20.5204C0 20.9665 0.361616 21.3281 0.807692 21.3281C1.25377 21.3281 1.61538 20.9665 1.61538 20.5204V18.1871C1.61538 17.1636 2.02195 16.1821 2.74565 15.4584Z" fill="#313131" />
                    </svg>
                </router-link>

                <Menu id="overlay_menu" ref="menu" :model="items" :popup="true" />
                <a @click="displayModal = true">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3856 8.57906C18.3856 5.22711 15.6727 2.51187 12.3286 2.51187C8.98461 2.51187 6.27168 5.22711 6.27168 8.57906C6.27168 11.931 8.98461 14.6462 12.3286 14.6462C15.6727 14.6462 18.3856 11.931 18.3856 8.57906ZM12.3286 0.896484C16.5671 0.896484 20.001 4.33722 20.001 8.57906C20.001 12.8209 16.5671 16.2616 12.3286 16.2616C10.5005 16.2616 8.82203 15.6215 7.50423 14.5531L2.11258 19.9528C1.79739 20.2684 1.28599 20.2688 0.970329 19.9536C0.654671 19.6384 0.654289 19.127 0.969479 18.8114L6.36275 13.4101C5.2955 12.0902 4.6563 10.4092 4.6563 8.57906C4.6563 4.33722 8.09019 0.896484 12.3286 0.896484Z" fill="#313131" />
                    </svg>
                </a>

                <Dialog :visible.sync="displayModal" :containerStyle="{ width: '30vw' }" :modal="true" :showHeader="false" :showFooter="false" class="search-input">
                    <div class="d-flex align-items-center gap-2 border px-3 py-4">
                        <button @click="goToSearch()" class="bg-white p-2">
                            <i class="pi pi-search" />
                        </button>
                        <InputText type="text" v-model="search" @keyup.enter="goToSearch()" placeholder="Search" class="p-4 w-100 shadow-0" />
                        <button class="bg-white p-2" @click="() => (displayModal = false)">
                            <i class="pi pi-times" />
                        </button>
                    </div>
                </Dialog>
            </div>
            <!-- </div> -->
        </div>
    </nav>
    <Sidebar :position="lang == 'en' ? 'right' : 'left'" :visible.sync="visibleLeft" :class="isTab() ? 'p-sidebar-lg' : 'p-sidebar-md'">
        <div class="p-4 product-eval">
            <div class="send d-flex align-items-center pe-4 mt-3">
                <h5 class="ms-2 mb-0">{{ $t("shopping cart") }}</h5>
                <span>{{ countCartItem }} {{ $t("product") }}</span>
                <button @click="
              visibleLeft = false;
              $router.push('/cart');
            ">
                    {{ $t("Go to shopping cart") }}
                </button>
            </div>
            <div class="total-orders d-flex align-items-center justify-content-between mb-4">
                <h5>{{ $t("Orders summary") }}</h5>
                <span>{{ $t("Subtotal") }}
                    <b class="pe-2">{{ cart.subTotal }} {{ $t("SAR") }}</b></span>
            </div>

            <div v-if="
            (cart && !cart?.cartItemsList) || cart?.cartItemsList?.length == 0
          " class="text-center">
                <img src="../assets/images/cartIllustartion.svg" class="mt-5" alt="" />
            </div>

            <div class="current-orders d-flex align-items-center position-relative" v-for="(item, index) of cart.cartItemsList" :key="index">
                <img :src="
              item.itemId &&
              item.itemId.colorsList &&
              item.itemId.colorsList.length > 0 &&
              item.itemId.colorsList[0].colorsImage.length > 0
                ? $baseUploadURL + item.itemId.colorsList[0].colorsImage[0].name
                : ''
            " alt="" />
                <div class="content">
                    <div class="content1">
                        <h5 style="width: 84%">
                            {{ $getByLang(item.itemId?.name) }}
                            <span v-if="item.packageId">
                                ({{ $getByLang(item.packageId.name) }})
                            </span>
                        </h5>
                        <span class="price d-block">{{ item.total }} {{ $t("SAR") }}
                            <del class="price" style="padding: 0px 10px; font-size: 16px; color: #a49d9d" v-if="item.offerId != null">{{ item.priceBefforOffer * item.quantity }}
                                {{ $t("SAR") }}</del>
                        </span>
                        <span class="q">الكمية:
                            <span>{{ $codePadding(item.quantity) }}</span>
                        </span>
                    </div>
                    <div class="basket position-absolute">
                        <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg" @click="removeItem(item)">
                            <path d="M21.4444 10.1L20.5297 22.1988C20.3248 24.908 18.1044 27 15.4336 27H9.56638C6.89564 27 4.67516 24.908 4.47033 22.1988L3.55556 10.1M24 7.5C20.6804 5.85417 16.7341 4.9 12.5 4.9C8.26589 4.9 4.31956 5.85417 1 7.5M9.94444 4.9V3.6C9.94444 2.16406 11.0886 1 12.5 1C13.9114 1 15.0556 2.16406 15.0556 3.6V4.9M9.94444 12.7V20.5M15.0556 12.7V20.5" stroke="#868696" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </Sidebar>
    <Sidebar :position="lang == 'en' ? 'right' : 'left'" :visible.sync="visibleLeftNtofy" :class="isTab() ? 'p-sidebar-lg' : 'p-sidebar-md'">
        <div class="p-4 product-eval">
            <div class="text-right pe-4 mt-3 mb-2">
                <h5 class="ms-2 text-right">{{ $t("notifications") }}</h5>
            </div>
            <div v-if="notificationsList.length == 0" class="text-center">
                <img src="../assets/images/noNotificationillustration.svg" class="mt-5" alt="" />
            </div>
            <div class="current-orders d-flex align-items-center position-relative" v-for="(item, index) of notificationsList" :key="index">
                <img :src="$baseUploadURL + item.image" alt="" style="height: 50px; width: auto" />
                <div class="content">
                    <div class="content1">
                        <p style="
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 20px;
                  color: #101817;
                ">
                            {{ $getByLang(item.text) }}
                        </p>
                        <p style="
                  font-size: 13px;
                  font-weight: 400;
                  line-height: 18px;
                  color: #828a89;
                ">
                            {{ $durationFormatFrom(item.createdAt) }}
                        </p>
                    </div>
                    <div class="basket position-absolute" @click="dNtofy(item._id)">
                        <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.4444 10.1L20.5297 22.1988C20.3248 24.908 18.1044 27 15.4336 27H9.56638C6.89564 27 4.67516 24.908 4.47033 22.1988L3.55556 10.1M24 7.5C20.6804 5.85417 16.7341 4.9 12.5 4.9C8.26589 4.9 4.31956 5.85417 1 7.5M9.94444 4.9V3.6C9.94444 2.16406 11.0886 1 12.5 1C13.9114 1 15.0556 2.16406 15.0556 3.6V4.9M9.94444 12.7V20.5M15.0556 12.7V20.5" stroke="#868696" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </Sidebar>
</div>
</template>

<script>
export default {
    name: "app-header",
    data() {
        const lang = localStorage.lang || "ar";
        const user = localStorage.homeHere ? JSON.parse(localStorage.homeHere) : "";

        return {
            search: null,
            whatsapp: null,
            user,
            lang,
            visibleLeft: false,
            visibleLeftNtofy: false,
            serach: null,
            displayModal: false,
            items: [{
                    label: this.$t("myprofile"),
                    icon: "pi pi-user",
                    command: () => {
                        this.$router.push("/myprofile");
                    }
                },
                {
                    label: this.$t("logout"),
                    icon: "pi pi-times",
                    command: () => {
                        delete localStorage.homeHere;
                        location.reload();
                    }
                }
            ],

            menuList: [{
                    label: this.$t("Home"),
                    to: "/"
                },
                {
                    label: this.$t("categories"),
                    items: []
                },
                {
                    label: this.$t("orders"),

                    to: "/orders"
                }
                // ,
                // {
                //   label: this.$t("vendorsRequests"),

                //   to: "/vendorsRequests"
                // }

            ],
            menuMobList: [{
                    label: this.$t("Home"),
                    to: "/"
                },
                {
                    label: this.$t("categories"),
                    items: []
                },
                {
                    label: this.$t("orders"),

                    to: "/orders"
                }
                // ,
                // {
                //   label: this.$t("vendorsRequests"),

                //   to: "/vendorsRequests"
                // }

            ],

            countCartItem: 0,
            cart: [],
            notificationsList: [],
            notificationsCount: 0
        };
    },
    methods: {
        isTab() {
            var windowWidth = window.innerWidth;

            return windowWidth < 955;
        },

        showData() {
            this.$http.post("notifications/showNotifications", {}).then((res) => {
                this.notificationsCount = 0;
            });
        },
        toggle(event) {
            this.$refs.menu.toggle(event);
        },
        goToSearch() {
            this.$router.push("/search?q=" + this.search);
            this.visibleLeft = false;
            this.search = null;
            this.displayModal = false;
        },
        getCarts() {
            if (localStorage.homeHere) {
                this.$http.get("cart").then((res) => {
                    if (
                        res.data.returnStatus &&
                        res.data &&
                        res.data.data &&
                        res.data.data.cartItemsList
                    ) {
                        this.countCartItem = res.data.data.cartItemsList.length;

                        this.cart = res.data.data;
                    } else {
                        this.countCartItem = 0;
                        this.cart = {};
                    }
                });
            }
        },
        getCartsWithoutReCalculate() {
            if (localStorage.homeHere) {
                this.$http.get("cart/withoutReCalculate").then((res) => {
                    if (
                        res.data.returnStatus &&
                        res.data &&
                        res.data.data &&
                        res.data.data.cartItemsList
                    ) {
                        this.countCartItem = res.data.data.cartItemsList.length;

                        this.cart = res.data.data;
                    } else {
                        this.countCartItem = 0;
                        this.cart = {};
                    }
                });
            }
        },
        removeItem(item) {

            this.$http.delete("cartDetails/" + item._id).then((res) => {

                this.getCarts();
                setTimeout(() => {
                    if (this.cart && this.cart.cartItemsList) {
                        if (this.cart.cartItemsList.length == 0) {
                            this.$http.delete("cart/" + this.cart._id)
                        }

                    }
                    console.log("11111111111111111111111111", this.cart.cartItemsList.length)

                }, 2000);

                // if (res.data.returnStatus) {
                // }
            });
        },

        dNtofy(id) {
            this.$http.delete("notifications/" + id).then((re2s) => {
                this.$http.post("notifications/getMyNotifications", {}).then((res) => {
                    this.notificationsList = res.data.data;
                });
            });
        },
        navigateToCategory(id) {
            this.$router.push(`/categories/${id}`).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        },
        changeLang(val) {
            localStorage.lang = val;
            this.$root.$i18n.locale = val;
            this.lang = val;

            this.$changeRtl(val);
            this.$eventHub.$emit("changeLang", val);
            if (val == 'ar') {
                document.getElementById("menuBar").style.direction = 'ltr'
            }
            if (val == 'en') {
                document.getElementById("menuBar").style.direction = 'rtl'
            }

            location.reload();
        },

        getNewNotfy() {
            this.$http
                .post("notifications/getMyNotificationsCount", {})
                .then((res) => {
                    if (res.data.data.count > this.notificationsCount) {
                        this.notificationsCount = res.data.data.count;
                        this.$http
                            .post("notifications/getMyNotifications", {})
                            .then((res) => {
                                this.notificationsList = res.data.data;
                            });
                    }
                });
        }
    },
    mounted() {
        this.getCarts();

        this.$eventHub.$on("changeLang", () => {
            this.items = [{
                    label: this.$t("myprofile"),
                    icon: "pi pi-user",
                    command: () => {
                        this.$router.push("/myprofile");
                    }
                },
                {
                    label: this.$t("logout"),
                    icon: "pi pi-times",
                    command: () => {
                        delete localStorage.homeHere;
                        location.reload();
                    }
                }
            ];

            this.menuList = [{
                    label: this.$t("Home"),
                    to: "/"
                },
                {
                    label: this.$t("categories"),
                    items: []
                },
                {
                    label: this.$t("orders"),

                    to: "/orders"
                }
                // ,
                //  {
                //   label: this.$t("vendorsRequests"),

                //   to: "/vendorsRequests"
                // }
            ];
        });

        this.$eventHub.$on("updateCart", () => {
            this.getCarts();
        });
    },
    created() {
        this.$http.get("settings?limit=4").then((res) => {
            this.whatsapp =
                res.data.docs.length > 0 ? res.data.docs[0].whatsapp : null;
        });

        this.$http.get("categories?limit=10000").then((res) => {
            const list = [];
            const list2 = [];
            this.$http.post("subCategories/getSubCategoriesByCategories?limit=10000").then((res2) => {
                const arr = res2.data.docs;
                for (const item of res.data.docs) {
                    const items = [];
                    let arrFilter = [];
                    for (const arr1 of arr) {
                        if (arr1.categoriesId != null) {
                            arrFilter.push(arr1);
                        }
                    }
                    const itemsList = arrFilter.filter(
                        (el) => el.categoriesId._id == item._id
                    );

                    for (const itm of itemsList) {

                        items.push({
                            label: this.$getByLang(itm.name),

                            to: "/products/" + itm._id
                        });
                    }
                    list.push([{
                        label: this.$getByLang(item.name),
                        items
                    }]);
                    list2.push({
                        items,
                        label: this.$getByLang(item.name),
                        // to: "/categories/" + item._id,
                        command: (event) => {
                            this.navigateToCategory(item._id);
                        },
                    });

                }

                // let c = 1;
                // let temp = [];

                // for (const item of res.data.docs) {
                //   const items = [];
                //   const itemsList = arr.filter((el) => el.categoriesId._id == item._id);

                //   for (const itm of itemsList) {
                //     items.push({
                //       label: this.$getByLang(itm.name),

                //       to: "/products/" + itm._id,
                //     });
                //   }
                //   temp.push({
                //     label: this.$getByLang(item.name),
                //     items,
                //   });

                //   if (c == 2) {
                //     list.push(temp);
                //     temp = [];
                //     c = 0;
                //   }
                //   c = c + 1;

                //   list2.push({
                //     label: this.$getByLang(item.name),
                //     items,
                //   });
                // }

                this.menuList[1].items = list;

                this.menuMobList[1].items = list2;

            });
        });

        setInterval(() => {
            if (localStorage.homeHere) {
                this.getNewNotfy();
            }
        }, 5000);
    }
};
</script>

<style>
ul li a.nav-link {
    color: #313131;
    font-weight: 500;
    font-size: 14px;
}

.logo img {
    height: 52px;
}

.logo img,
.logo button {
    margin: 0 10px;
}

.lang-btn {
    color: #000000;
    border: none;
    border-radius: 3px;
    margin-right: 32px !important;
}

.navbar .icons a {
    color: #313131;
    margin: 0 14px;
    font-size: 20px;
}

.p-menu.p-menu-overlay {
    width: 300px;
}

.p-menu .p-menuitem-link .p-menuitem-icon {
    color: #6c757d;
    margin-left: 0.5rem;
}

.icons .person {}

.count-bell2 {
    font-size: 7px !important;
    padding-top: 3px !important;
    margin-top: 10px !important;
    background-color: #f59f00;
    position: absolute;
    margin-right: -29px;
}
</style>
